export default __webpack_public_path__ + "static/media/embeddable_figures.da3bcddd.svg";